<template>
  <div>
    <div class="hero hero-cover hero-gradient">
      <div class="container">
        <h1 class="text-white text-center">Projekti</h1>
      </div>
    </div>

    <div class="section bg-white text-gray-700 push-content">
      <div class="container">
        <p
          class="text-center text-xl xl:text-2xl italic font-light"
          v-scroll-reveal
        >
          U nastavku vam donosimo prikaz nekoliko odabranih projekata koje smo
          odradili u suradnji s našim korisnicima. Svi prikazani projekti
          zahtijevali su projektiranje, implementaciju i razvoj cjelokupnih
          elektro-energetskih sustava. Primjenom najboljih praksi te
          prilagođavanjem konkretnim situacijama i potrebama korisnika, sve
          navedene projekte uspješno smo realizirali u ugovorenim rokovima uz
          korištenje kvalitetne opreme i najsuvremenijih alata te mjernih
          instrumenata.
        </p>
      </div>

      <div class="container _xl mt-8 md:mt-12">
        <div class="links flex flex-wrap items-center justify-center">
          <router-link
            :to="{ name: 'projects' }"
            class="link-item"
            :class="{ active: selectedService === null }"
            v-scroll-reveal
            >Izabrani projekti</router-link
          >
          <!-- <span class="block w-full"></span> -->
          <router-link
            v-for="(service, i) in services"
            :key="`service-${service.slug}`"
            :to="{
              name: 'projects-by-service',
              params: { service: service.slug },
            }"
            class="link-item"
            :class="{ active: service.slug == selectedService }"
            v-scroll-reveal
            >{{ service.name }}</router-link
          >
        </div>
      </div>
    </div>

    <div class="projects section bg-gray-100 text-secondary">
      <div class="container _xl pull-content">
        <div class="flex flex-wrap -mb-8 md:-mb-12 md:-mx-2 lg:-mx-3">
          <div
            v-for="(project, i) in projects"
            :key="`project-${i}`"
            class="w-full md:w-1/2 md:px-2 lg:px-3 mb-8 md:mb-12"
            v-scroll-reveal
          >
            <router-link
              v-if="selectedService !== 'suprasolar'"
              :to="{ name: 'project', params: { slug: project.slug } }"
              class="carousel-image has-hover-effect"
              :style="{
                backgroundImage: `url(${
                  project.card ? project.card : project.image
                })`,
              }"
            ></router-link>
            <figure
              v-else
              class="carousel-image has-hover-effect"
              :style="{
                backgroundImage: `url(${
                  project.card ? project.card : project.image
                })`,
              }"
            ></figure>

            <h3 class="my-6" v-text="project.name"></h3>

            <span
              class="block font-light"
              v-text="project.services_list"
            ></span>
            <span
              class="block font-light mt-1"
              v-text="project.timeframe"
            ></span>
          </div>
        </div>
        <infinite-loading @infinite="getProjects" spinner="spiral">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
          <div slot="error" slot-scope="{ trigger }">
            Došlo je do greške, klikni
            <a href="javascript:;" @click="trigger">ovdje</a>
          </div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import { SupraSolarProjects } from "../../config/suprasolar";

export default {
  components: {
    InfiniteLoading,
  },

  data() {
    return {
      services: {},
      projects: [],
      page: 1,
    };
  },

  computed: {
    selectedService() {
      return _.isUndefined(this.$route.params.service)
        ? null
        : this.$route.params.service;
    },
  },

  watch: {
    selectedService(val, oldVal) {
      if (val != oldVal) {
        this.page = 1;
        this.projects = [];
        this.getProjects();
      }
    },
  },

  mounted() {
    this.getServices();
  },

  methods: {
    getServices() {
      this.$http
        .get("/services", {
          params: {
            filter: true,
          },
        })
        .then((response) => {
          this.services = response.data.data;

          this.services.push({
            id: 999,
            name: "SupraSolar",
            slug: "suprasolar",
          });
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
        });
    },
    getProjects($state) {
      if (this.selectedService === "suprasolar") {
        this.projects = SupraSolarProjects;

        return;
      }

      this.$http
        .get(
          this.selectedService === null
            ? "/projects"
            : `/projects?service=${this.selectedService}`,
          {
            params: {
              page: this.page,
            },
          }
        )
        .then((response) => {
          let data = response.data.data;

          if (!_.isEmpty(data)) {
            this.projects.push(...response.data.data);
            this.page += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
        });
    },
  },

  metaInfo: {
    title: "Projekti",
    meta: [
      {
        vmid: "og:image",
        property: "og:image",
        content: "https://www.supranet.hr/img/projects/projects.jpg",
      },
    ],
  },
};
</script>
